
import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="container mx-auto px-4 text-left">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-4xl mx-auto">
          <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
          
          <div className="prose prose-gray max-w-none">
            <p>
              This Privacy Policy describes how your personal information is collected, used, and shared when you use our application.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Personal Information We Collect at Clou</h2>
            <p>
              When you use our app, we collect certain information from you, including:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Contact information (name, email address)</li>
              <li>Account credentials</li>
              <li>User content (journal entries, notes)</li>
              <li>Usage data and analytics</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">How We Use Your Information</h2>
            <p>
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Provide, maintain, and improve our services</li>
              <li>Process transactions</li>
              <li>Send you technical notices and support messages</li>
              <li>Respond to your comments and questions</li>
              <li>Develop new products and services</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Sharing Your Information</h2>
            <p>
              We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Service providers who perform services on our behalf</li>
              <li>Professional advisors, such as lawyers and accountants</li>
              <li>Government entities when required by law</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Data Security</h2>
            <p>
              We implement reasonable security measures to protect your personal information from unauthorized access, use, or disclosure.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Your Rights</h2>
            <p>
              Depending on your location, you may have certain rights regarding your personal information, such as:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access to your personal information</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your information</li>
              <li>Objection to certain processing activities</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time to reflect changes in our practices or for other operational, legal, or regulatory reasons.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Contact Us</h2>
            <p>
              For more information about our privacy practices, or to exercise your rights, please contact us at:
            </p>
            <p className="mt-2">
              <strong>Email:</strong> administrator@clamalo.com
            </p>
            <p>
              <strong>Address:</strong> Apartado 682, Lagos, Portugal 8600-999
            </p>
            
            <p className="mt-6 text-sm text-gray-500">
              Last updated: March 1, 2023
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
